import { Injectable } from '@angular/core';
import { HttpClientService } from './http-client.service';
import { Observable } from 'rxjs';
import { Rubro } from '../models/rubro';
import { environment } from '../../environments/environment';

const baseUrl = environment.hostService + '/Rubros';

@Injectable({
  providedIn: 'root'
})
export class RubrosService {

  constructor(private _http: HttpClientService) { }

  getAll(): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/Index' })
  }

  save(entidad: Rubro)
  {
    return this._http.post({ url: baseUrl + '/Save', body: entidad });
  }

  delete(id: number)
  {
    return this._http.get<any>({ url: baseUrl + '/Delete?id=' + id });   
  }
}

